var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 27.7",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "House Roof") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m47.8 21.5l-1-1-9.5-9.5v-4.6c0-0.2-0.2-0.4-0.4-0.4h-4c-0.2 0-0.3 0.1-0.3 0.3l-5.2-5.3-1-1-6.7 6.7-1.2-1.2-0.8-0.9-16.8 16.7-0.7 0.7c-0.2 0.2-0.2 0.6 0 0.9 0.1 0.1 0.2 0.1 0.4 0.1s0.3 0 0.4-0.2l2.2-2.2v6.5c0 0.3 0.2 0.5 0.5 0.5s0.5-0.2 0.5-0.5v-7c0-0.1-0.1-0.3-0.1-0.3l11.3-11.4 2.1-2.1 2 2 11.7 11.7v0.1 7c0 0.3 0.2 0.5 0.5 0.5s0.5-0.2 0.5-0.5v-6.1l1.7 1.7c0.1 0.1 0.3 0.2 0.4 0.2 0.2 0 0.3-0.1 0.4-0.2 0.2-0.2 0.2-0.6 0-0.8l-0.6-0.6-13.5-13.5 5.7-5.7 2.9 2.9s0 0.1 0.1 0.1l13.9 13.9v8.1c0 0.3 0.3 0.6 0.6 0.6s0.6-0.3 0.6-0.6v-6.9l2.3 2.3c0.1 0.1 0.3 0.2 0.5 0.2s0.4-0.1 0.5-0.2c0.4-0.3 0.4-0.7 0.1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.3 14.8h-5.5c-0.4 0-0.8 0.3-0.8 0.6v5.8c0 0.3 0.4 0.6 0.8 0.6h5.5c0.4 0 0.8-0.3 0.8-0.6v-5.8c0-0.3-0.3-0.6-0.8-0.6zm-3 6.6h-2.4c-0.1 0-0.2-0.1-0.2-0.1v-2.7h2.6v2.8zm0-3.3h-2.6v-2.7c0-0.1 0.1-0.1 0.2-0.1h2.4v2.8zm3.2 3.2c0 0.1-0.1 0.1-0.2 0.1h-2.4v-2.8h2.6v2.7zm0-3.2h-2.6v-2.8h2.4c0.1 0 0.2 0.1 0.2 0.1v2.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoof);
export default __webpack_public_path__ + "static/media/roof.51f983bb543708216142e2a05677289c.svg";
export { ForwardRef as ReactComponent };